import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import { pathOr } from 'ramda'

import * as actions from './actions'
import * as OrgActions from 'modules/org/actions'
import * as BillingActions from 'modules/billing/actions'

const name = handleActions({
  [actions.setName]: (state, action) => action.payload,
  [actions.fetchUserSuccess]: (state, action) => action.payload.name,
  [actions.fetchClearbitForEmailSuccess]: (state, action) => action.payload.response.name || ''
}, '')

const email = handleActions({
  [actions.setEmail]: (state, action) => action.payload,
  [OrgActions.createOrgSuccess]: (state, action) => action.payload.response.user.email,
  [actions.fetchUserSuccess]: (state, action) => action.payload.email,
  [BillingActions.fetchDealSuccess]: (state, action) => pathOr('', ['customerInfo', 'emailAddress'], action.payload),
  [actions.fetchEmailFromRelaySuccess]: (state, action) => pathOr('', ['subject'], action.payload),
  [actions.fetchUserWithoutNameSuccess]: (state, action) => action.payload.email,
}, '')

const flow = handleActions({
  [actions.setFlow]: (state, action) => state || action.payload,
}, '')

const password = handleActions({
  [actions.setPassword]: (state, action) => action.payload,
}, '')

const userId = handleActions({
  [OrgActions.createOrgSuccess]: (state, action) => action.payload.response.user.id,
  [actions.fetchUserSuccess]: (state, action) => action.payload.id,
  [actions.fetchUserWithoutNameSuccess]: (state, action) => action.payload.id,
}, false)

const passwordUpdateStatus = handleActions({
  [actions.updatePasswordPending]: (state, action) => 'pending',
  [actions.updatePasswordSuccess]: (state, action) => 'success',
  [actions.updatePasswordFailed]: (state, action) => 'failed',
}, false)

const passwordConfig = handleActions({
  [actions.updatePasswordFailed]: (state, action) => JSON.parse(action.payload.response.message),
}, {})

const passwordConfigFetched = handleActions({
  [actions.updatePasswordFailed]: (state, action) => true,
}, false)

const userJwt = handleActions({
  [OrgActions.createOrgSuccess]: (state, action) => action.payload.response.user.userJwt,
  [actions.fetchUserSuccess]: (state, action) => action.payload.userJwt,
}, false)

const uniqueEmail = handleActions({
  [actions.checkUniqueEmailFailed]: () => false,
  [actions.checkUniqueEmailSuccess]: () => true,
}, true)

const validEmail = handleActions({
  [actions.setValidEmail]: (state, action) => action.payload,
}, true)

const disabledEmail = handleActions({
  [actions.setDisabledEmail]: (state, action) => action.payload,
}, false)

const profilePicture = handleActions({
  [actions.stageProfilePicture]: (state, action) => action.payload,
}, null)

const avatarUrl = handleActions({
  [actions.setAvatarUrl]: (state, action) => action.payload,
  [actions.fetchClearbitForEmailSuccess]: (state, action) => action.payload.response.avatarUrl || null,
  [actions.fetchUserSuccess]: (state, action) => action.payload.avatarUrl,
}, null)

const resetToken = handleActions({
  [actions.setResetToken]: (state, action) => action.payload
}, null)

const domainFound = handleActions({
  [actions.setAssociatedDomainFound]: (state, action) => action.payload
}, false)

const hidePopup = handleActions({
  [actions.setHidePopup]: (state, action) => action.payload
}, false)

const findMyTeamVerificationEmailStatus = handleActions({
  [actions.sendFindMyTeamVerificationEmailSuccess]: (state, action) => 'success',
  [actions.sendFindMyTeamVerificationEmailFailure]: (state, action) => 'failure',
  [actions.sendFindMyTeamVerificationEmailReset]: (state, action) => 'reset',
}, null)

const accessToken = handleActions({
  [OrgActions.createOrgSuccess]: (state, action) => action.payload.response.accessToken.accessToken,
}, null)

const SSOProvisionedFlow = handleActions({
  [actions.setSSOProvisionedFlow]: (state, action) => action.payload
}, null)

const SSORedirectError = handleActions({
  [actions.getLoginUrlFailed]: () => true
}, null)

const checkEmailIsSSOEnabledStatus = handleActions({
  [actions.checkEmailIsSSOEnabledSuccess]: () => 'success',
  [actions.checkEmailIsSSOEnabledFailed]: () => 'failed',
  [actions.checkEmailIsSSOEnabledPending]: () => 'pending',
}, null)

const emailIsSSOEnabled = handleActions({
  [actions.checkEmailIsSSOEnabledSuccess]: (state, action) => action.payload.canLogIn,
}, null)

const isCalendarSeatOnboarding = handleActions({
  [actions.setIsCalendarSeatOnboarding]: (state, action) => action.payload
}, false)

const redeemedRelayStateSuccess = handleActions({
  [actions.fetchEmailFromRelaySuccess]: (state, action) => true,
}, '')

export default combineReducers({
  name,
  email,
  flow,
  password,
  userId,
  uniqueEmail,
  validEmail,
  profilePicture,
  resetToken,
  accessToken,
  SSOProvisionedFlow,
  SSORedirectError,
  checkEmailIsSSOEnabledStatus,
  emailIsSSOEnabled,
  avatarUrl,
  userJwt,
  isCalendarSeatOnboarding,
  disabledEmail,
  domainFound,
  hidePopup,
  findMyTeamVerificationEmailStatus,
  passwordUpdateStatus,
  passwordConfig,
  passwordConfigFetched,
  redeemedRelayStateSuccess,
})



// WEBPACK FOOTER //
// ./src/modules/user/reducer.js